import { cn } from "@/lib/utils";

type LogoVariant = "full" | "mark" | "wordmark";

interface LogoProps {
  variant?: LogoVariant;
  className?: string;
  /** Високота в px. Ширина — пропорційна. */
  height?: number;
}

/**
 * Sphere Energy логотип.
 * - `full`     — сфера + текст «SPHERE ENERGY». Для login-сторінки, експорт-шапок.
 * - `mark`     — лише сфера. Для сайдбара, favicon, компактних місць.
 * - `wordmark` — лише текст. Зарезервовано (поки не використовується).
 */
export function Logo({ variant = "full", className, height = 40 }: LogoProps) {
  if (variant === "mark") {
    return (
      <img
        src="/logo-mark.png"
        alt="Sphere Energy"
        className={cn("inline-block select-none", className)}
        style={{ height }}
        draggable={false}
      />
    );
  }

  if (variant === "wordmark") {
    return (
      <span
        className={cn(
          "inline-flex items-baseline gap-2 select-none font-bold tracking-wide",
          className,
        )}
        style={{ fontSize: height * 0.45 }}
      >
        <span className="text-brand-navy-500">SPHERE</span>
        <span className="text-brand-teal-500" style={{ fontSize: height * 0.32 }}>
          ENERGY
        </span>
      </span>
    );
  }

  // full
  return (
    <img
      src="/logo.png"
      alt="Sphere Energy"
      className={cn("inline-block select-none", className)}
      style={{ height }}
      draggable={false}
    />
  );
}
